export default function addSpacesToPDCN(partnerDiscountCardNumber) {
  return partnerDiscountCardNumber.split('').map((char, index) => {
    if ([2, 6, 13].includes(index)) {
      return ` ${char}`;
    }
    return char;
  }).join('');
}
